import { render } from "./ProposalActionOpinionControl.vue?vue&type=template&id=35c2908e&scoped=true"
import script from "./ProposalActionOpinionControl.vue?vue&type=script&lang=js"
export * from "./ProposalActionOpinionControl.vue?vue&type=script&lang=js"

import "./ProposalActionOpinionControl.vue?vue&type=style&index=0&id=35c2908e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c2908e"]])

export default __exports__